module.exports = __webpack_public_path__ + "img/f5fde7a0713c57460e28acb04870371a.png";